module.exports = __webpack_public_path__ + "img/stock_check_image.d6e8ae7b.png";